const TOKEN = /{{([a-zA-Z]+\.[a-zA-Z]+)}}/g;
export function renderLetterTokens(template, values) {
    for (const match of template.matchAll(TOKEN)) {
        const token = match[1];
        if ((values[token] ?? '').trim() === '') {
            return { ok: false, refusal: { kind: 'missing_value', token } };
        }
    }
    const text = template.replace(TOKEN, (_whole, token) => values[token]);
    if (/{{|}}|{[a-zA-Z]+\.[a-zA-Z]+}/.test(text)) {
        return { ok: false, refusal: { kind: 'leftover_placeholder' } };
    }
    return { ok: true, text };
}
const longDate = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
});
export function formatLetterDate(date) {
    const [year, month, day] = date.split('-').map(Number);
    return longDate.format(Date.UTC(year, month - 1, day));
}
export function unitAddressLines(address, unitIdentifier) {
    const unit = unitIdentifier?.trim();
    return [
        unit ? `${address.street}, Unit ${unit}` : address.street,
        `${address.city}, ${address.state} ${address.zipCode}`,
    ];
}
//# sourceMappingURL=letterTokens.js.map